import config from '@/config'
import pairingAPIs from '../components/views/Pairing/pairingAPIs'
import apiService from '../services/apiService'
const pairingServiceBaseURL = config.apiServiceBaseURL.pairing // use of pairing service base url
const pairingServiceOpenBaseURL = config.apiServiceBaseURL.pairingOpen // use of pairing service base url
const state = {
  pairings: [],
  pairingDetails: {},
  unsubmittedInfluencers: [],
  status: {
    NEW: {
      text: 'New',
      value: 0
    },
    ELIMINATION_PENDING: {
      text: 'In Elimination',
      value: 1
    },
    APPROVED: { // Client approved influencer by select
      text: 'Approved',
      value: 2
    },
    INVITED: {
      text: 'Invited',
      value: 3
    },
    INTERESTED: { // Influencer
      text: 'Interested',
      value: 4
    },
    NOT_INTERESTED: { // Influencer
      text: 'Not Interested',
      value: 5
    },
    ACCEPTED: { // CO/AM
      text: 'Accepted',
      value: 6
    },
    NOT_ACCEPTED: { // CO/AM
      text: 'Not Accepted',
      value: 7
    },
    INQUIRY: {
      text: 'Inquiry',
      value: 8
    }
  },
  savedCOGSApproval: false,
  requestedPayoutEdit: false,
  saved: false,
  infLists: []
}

const actions = {
  /**
   * Get all pairing lists
   * @param {*} commit
   * @returns
   */
  async getPairings ({ commit }) {
    try {
      let response = await pairingAPIs.getAllPairings()
      if (response) {
        commit('SET_PAIRINGS', response)
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Get pairing influencers lists which are not posted
   * @param {*} commit
   * @returns
   */
  async getPostUnsubmittedPairingInfluencers ({ commit }, filter) {
    try {
      let response = await pairingAPIs.getPostUnsubmittedPairingInfluencers(filter)
      if (response) {
        commit('SET_UNSUBMITTED_INFLUENCERS', response)
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save get approval amount for activity object
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async saveAmountApproval ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'savedAmountApproval',
        data: false
      })
      await apiService.post(pairingServiceBaseURL + '/update/approval-amount', data)
      commit('SET_DATA', {
        name: 'savedAmountApproval',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save get approval cogs amount for activity object
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async saveCOGSApproval ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'savedCOGSApproval',
        data: false
      })
      await apiService.post(pairingServiceBaseURL + '/request/cogs/approval-amount', data)
      commit('SET_DATA', {
        name: 'savedCOGSApproval',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * update payout activity for accept or reject
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async updatePayoutActivity ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'savedPayoutActivity',
        data: false
      })
      await apiService.post(pairingServiceBaseURL + '/update/payout-activity', data)
      commit('SET_DATA', {
        name: 'savedPayoutActivity',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * send payout edit request
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async requestPayoutEdit ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'requestedPayoutEdit',
        data: false
      })
      await apiService.post(pairingServiceBaseURL + '/request/payout/edit', data)
      commit('SET_DATA', {
        name: 'requestedPayoutEdit',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Get pairing details
   * @param {*} commit
   * @returns
  */
  async getPairingDetails ({ commit }, id) {
    try {
      commit('SET_DATA', {
        name: 'pairingDetails',
        data: {}
      })
      let response = await apiService.get(pairingServiceOpenBaseURL + '/' + id)
      if (response) {
        commit('SET_DATA', {
          name: 'pairingDetails',
          data: response
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Get pairing details for submit payout
   * @param {*} commit
   * @returns
  */
  async getPairingDetailsForStats ({ commit }, id) {
    try {
      commit('SET_DATA', {
        name: 'pairingDetails',
        data: {}
      })
      let response = await apiService.get(pairingServiceOpenBaseURL + '/' + id + '?stats=true')
      if (response) {
        commit('SET_DATA', {
          name: 'pairingDetails',
          data: response
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Get pairing by handle
   * @param {*} commit
   * @returns
  */
  async getPairingsByHandle ({ commit }) {
    try {
      let response = await pairingAPIs.getAllPairings()
      if (response) {
        commit('SET_PAIRINGS', response)
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },

  /**
   * get pairing accepted infs
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async getPairingAcceptedInfs ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'pairings',
        data: []
      })
      let resp = await apiService.post(pairingServiceBaseURL + '/paired/accepted-influencer', data)
      commit('SET_DATA', {
        name: 'pairings',
        data: resp
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save creator sign in form
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async saveSignInForm ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'saved',
        data: false
      })
      await apiService.post(pairingServiceOpenBaseURL + '/save/signin-form', data)
      commit('SET_DATA', {
        name: 'saved',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * cancel pairing accept
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async cancelPairingStatus ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'saved',
        data: false
      })
      await apiService.post(pairingServiceBaseURL + '/cancel/pairing/status', data)
      commit('SET_DATA', {
        name: 'saved',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * get creator concept pairings
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async getCreatorConceptPairing ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'pairings',
        data: []
      })
      let resp = await apiService.post(pairingServiceBaseURL + '/paired/creator-concepts', data)
      commit('SET_DATA', {
        name: 'pairings',
        data: resp
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * save pairing for inf billing details payment consolidation for non-registered infs
   * @param {*} commit
   * @param {*} data
   * @returns
  */
  async savePairingBillingInfo ({commit}, data) {
    try {
      commit('SET_DATA', {
        name: 'saved',
        data: false
      })
      await apiService.post(pairingServiceBaseURL + '/paired/billing-info', data)
      commit('SET_DATA', {
        name: 'saved',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Get inf Lists
   * @param {*} commit
   * @returns
  */
  async getInfLists ({ commit }) {
    try {
      commit('SET_DATA', {
        name: 'infLists',
        data: []
      })
      let response = await apiService.get(pairingServiceBaseURL + '/inf-lists')
      if (response) {
        commit('SET_DATA', {
          name: 'infLists',
          data: response
        })
      }
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Delete Inf Data
   * @param {*} commit
   * @returns
  */
  async deleteInfListData ({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'saved',
        data: false
      })
      await apiService.post(pairingServiceBaseURL + '/delete/inf-lists', payload)
      commit('SET_DATA', {
        name: 'saved',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  },
  /**
   * Delete Inf detail data
   * @param {*} commit
   * @returns
  */
  async deleteInfDetailData ({ commit }, payload) {
    try {
      commit('SET_DATA', {
        name: 'saved',
        data: false
      })
      await apiService.post(pairingServiceBaseURL + '/delete/inf-detail-data', payload)
      commit('SET_DATA', {
        name: 'saved',
        data: true
      })
    } catch (err) {
      console.error(err)
      return ''
    }
  }
}

const getters = {
  status: state => state.status
}

/**
 * Need actions to implement
 */
// const actions = {}

const mutations = {
  updateStatus: (state, value) => {
    state.status = value
  },
  SET_PAIRINGS(state, data) {
    state.pairings = data
  },
  SET_UNSUBMITTED_INFLUENCERS(state, data) {
    state.unsubmittedInfluencers = data
  },
  SET_DATA(state, { name, data }) {
    state[name] = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/pairing.js